import { gql } from 'react-apollo';

export const deactivateUser = gql`
  mutation deactivateUser($input: DeactivateUserInput!) {
    deactivateUser(input: $input) {
      user {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/deactivateUser.js